import { render } from "./SubSection.vue?vue&type=template&id=219e4077&scoped=true"
import script from "./SubSection.vue?vue&type=script&lang=js"
export * from "./SubSection.vue?vue&type=script&lang=js"

import "./SubSection.vue?vue&type=style&index=0&id=219e4077&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219e4077"]])

export default __exports__